import ApiService from "./index";
const resourceList = "/api/Systems/GetNews";

const News = {
    getList() {
        return ApiService.get(resourceList);
    },
    get(id) {
        return ApiService.get("/api/Systems/DetailNews?id="+id);
    },
};

export default News;


// WEBPACK FOOTER //
// ./src/common/api/news.js